import { legendsConfiguration } from './types.js';
export const getLegendsConfiguration = ({
  isPopout
}: {
  isPopout: boolean;
}): legendsConfiguration => ({
  legendsOffsetTop: 2,
  legendsOffsetLeft: 3.25,
  legendsColumnCount: 0,
  legendsHorizontalGap: isPopout ? 0 : 4,
  legendsVerticalGap: isPopout ? 6 : 4,
  legendIcon: {
    width: isPopout ? 22 : 20,
    height: isPopout ? 13 : 11
  },
  legendName: {
    typography: isPopout ? 'label-300' : 'label-100',
    offsetLeft: isPopout ? 4 : 2,
    maxWidth: isPopout ? 300 : undefined,
    whiteSpace: isPopout ? undefined : 'nowrap'
  }
});